import moment from "moment";
import "moment/locale/ru";
import getDayNameByNumer from "./getDayNameByNumer";

export default function groupGetFullInfo(g) {
  return ` ${g.name} | ${g.visitingDays
    .map((g) => getDayNameByNumer(g))
    .join(",")} | ${g.visitingTime}`;
}
